/* eslint-disable class-methods-use-this */
export default class ProtectData {
  protectString = (data?: string) => {
    if (!data || data.length <= 0) {
      return '';
    }
    if (data.length <= 4) {
      return data;
    }
    return `${data
      .slice(0, data.length - 4)
      .split('')
      .map(() => '*')
      .join('')}${data.substring(data.length - 4)}`;
  };
}
